import * as React from "react";
function SvgIcLoginYes2(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={7} cy={7} r={7} fill="#17CC12" /><path fillRule="evenodd" clipRule="evenodd" d="M10.517 4.456c.3.286.312.76.027 1.06l-3.803 4a.75.75 0 01-1.075.014L3.47 7.33a.75.75 0 111.062-1.06l1.653 1.656 3.272-3.443a.75.75 0 011.06-.027z" fill="#fff" /></svg>;
}
export default SvgIcLoginYes2;